import { useEffect, useState } from 'react';
export const useShowContentDiscussion = ({ isMinimized, isPlaying, isDesiredPlayerOrientationPortrait, isAppPortrait, }) => {
    const [showContentDiscussion, setShowContentDiscussion] = useState();
    useEffect(() => {
        if (!isMinimized
            && isPlaying
            && isAppPortrait
            && isDesiredPlayerOrientationPortrait) {
            setShowContentDiscussion(true);
        }
        else {
            setShowContentDiscussion(false);
        }
    }, [
        isMinimized,
        isAppPortrait,
        isDesiredPlayerOrientationPortrait,
    ]);
    return showContentDiscussion;
};
//# sourceMappingURL=useShowContentDiscussion.js.map